import { useCallback, useMemo } from 'react';
import uuid from 'uuid/v1';
import { useFormFieldValue } from '../../formData';

export const useExternalMetadata = (isRemovable, externalDataReadonlyFields, externalMetadataKeyLabels) => {
    const { value: externalMetadata = [], onChange } = useFormFieldValue({
        field: 'externalMetadata.data',
    });

    const onRemove = useCallback(
        itemToRemove => {
            onChange(externalMetadata.filter(item => item.key !== itemToRemove.key));
        },
        [externalMetadata, onChange]
    );

    const onAdd = useCallback(
        async item => {
            onChange([{ ...item, id: uuid() }, ...externalMetadata]);
        },
        [externalMetadata, onChange]
    );

    const externalMetadataWithIds = useMemo(
        () =>
            externalMetadata.map(item => ({
                ...item,
                id: item.id ?? item.key,
                label: externalMetadataKeyLabels[item.key] ?? item.key,
                isRemovable: item.isNew || isRemovable,
                isEditable: item.isNew || !externalDataReadonlyFields.includes(item.key),
            })),
        [externalDataReadonlyFields, externalMetadata, isRemovable, externalMetadataKeyLabels]
    );

    return { externalMetadata: externalMetadataWithIds, onAdd, onRemove, onChange };
};
